<template>
  <v-card
    class="mt-4 pa-4"
    border
  >
    <h4 class="mb-1 text-subtitle-2">
      {{ $t('labels.tags') }}
    </h4>

    <template v-if="crmConfig?.isActive">
      <div
        v-for="tagGroup in Object.keys(tagGroups)"
        :key="tagGroup"
      >
        <h5 class="mb-1 text-body-2 font-weight-bold">
          {{ $t('labels.from') }} {{ crmConfig.crmProvider }} ({{ tagGroups[tagGroup].length }})
        </h5>
        <v-chip
          v-for="tag in tagGroups[tagGroup]"
          :key="tag"
          class="mt-2 mr-2"
          rounded
        >
          {{ prepareTag(tag) }}
        </v-chip>
      </div>
    </template>
    <template v-else>
      <h5 class="mb-1 text-body-2">
        {{ $t('lead.tags-box.info') }}
      </h5>
      <div class="d-flex justify-space-between">
        <h5
          @click="handleLinkClick"
          class="mb-1 text-primary text-body-2 text-decoration-underline align-self-center cursor-pointer"
        >
          {{ $t('lead.tags-box.link.label') }}
        </h5>
        <v-btn
          class="mt-2"
          color="primary"
          @click="
            $router.push({
              name: 'Settings',
              params: { section: 'crm' },
              query: {
                'settings-open': 'crm',
              },
            })
          "
        >
          {{ $t('lead.tags-box.button.label') }}
        </v-btn>
      </div>
    </template>
  </v-card>
</template>

<script>
import crmMixin from '@/mixins/crm.js'

export default {
  mixins: [crmMixin],
  props: {
    lead: { type: Object, default: null },
  },
  computed: {
    tagGroups() {
      const tagGroups = {}
      this.lead.tags
        .filter((tag) => tag.startsWith('crm:'))
        .forEach((tag) => {
          const group = tag.split(':')[0]
          if (!tagGroups[group]) {
            tagGroups[group] = []
          }
          tagGroups[group].push(tag)
        })
      return tagGroups
    },
  },
  methods: {
    handleLinkClick() {
      this.$emit('updateCrmCompanyConfig')
      this.$emit('triggerTracking')
    },
    prepareTag(tag) {
      const tagNameArray = tag.split(':')
      return tagNameArray[tagNameArray.length - 1]
    },
  },
  emits: ['updateCrmCompanyConfig', 'triggerTracking'],
}
</script>
